import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

// Prefer real history-back so the browser back button behaves naturally.
// For deep links (no in-app history), fall back to a known safe route.
export function useSmartBack(fallbackPath: string) {
  const navigate = useNavigate()

  return useCallback(() => {
    const historyState = window.history.state as { idx?: number } | null
    const canGoBack = typeof historyState?.idx === 'number' ? historyState.idx > 0 : window.history.length > 1

    if (canGoBack) {
      navigate(-1)
      return
    }

    navigate(fallbackPath)
  }, [fallbackPath, navigate])
}
